<template>
  <div>
    <div>
      <h1>Portal DDS Digital</h1>
      <!-- Modal de termos de uso  -->
      <div  class="new-card hidden" id="modalTermoLabel">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Termos de Uso
              </h5>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  {{ term.description }}
                  <h3 class="mt-3">Assinatura:</h3>
                  <div style="border: inset;">
                    <vue-signature ref="signature" id="signature" :options="option" :width="'auto'" :height="'auto'"
                      :disabled="disabled" :default-url="dataUrl">
                    </vue-signature>
                  </div>

                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="logout">
                Não aceito!
              </button>
              <button type="button" class="btn btn-primary" @click="handleAccept">
                Aceito!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalTermo" tabindex="-1" aria-labelledby="modalTermoLabel" aria-hidden="true"
      data-bs-keyboard="false" data-bs-backdrop="static" style="overflow-x:auto;">
    </div>

    <div class="ibox animated fadeInRightBig mt-2">
      <div class="ibox-title">Dashboard</div>
      
      <!-- Tabs Navigation -->
      <ul class="nav nav-tabs" id="dashboardTabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" :class="{ active: activeTab === 'dds' }" 
                  @click="switchTab('dds')" 
                  type="button" 
                  role="tab">
            DDS
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" :class="{ active: activeTab === 'checklist' }" 
                  @click="switchTab('checklist')" 
                  type="button" 
                  role="tab">
            Checklist
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" :class="{ active: activeTab === 'ocorrencias' }" 
                  @click="switchTab('ocorrencias')" 
                  type="button" 
                  role="tab">
            Ocorrências
          </button>
        </li>
      </ul>

      <!-- Tabs Content -->
      <div class="tab-content" id="dashboardTabsContent">
        <!-- Aba DDS -->
        <div class="tab-pane" :class="{ 'show active': activeTab === 'dds' }" id="dds" role="tabpanel">
          <div class="mt-5 mb-5"
            style="background-color: white; display: flex; justify-content: space-between; padding: 0 15px;padding-bottom: 1%;">
            <div style="width: 25%;margin-left: 20%;">
              <label for="startDate" class="form-label">Data Inicial:</label>
              <input type="date" id="startDate" v-model="startDate" class="form-control" />
            </div>
            <div style="width: 25%;">
              <label for="endDate" class="form-label">Data Final:</label>
              <input type="date" id="endDate" v-model="endDate" class="form-control" />
            </div>
            <div style="width: 25%;">
              <button class="btn btn-primary mt-2" @click="fetchDashboardData">Pesquisar</button>
            </div>
          </div>

          <div class="ibox-content" style="min-height: 400px">
            <div class="row">
              <div class="col-md-9">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Participação dos Colaboradores
                      <br />
                      <span class="subtitle">Quantidade de Convites X Quantidade de Confirmações de Presença</span>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <BarChart id="Chart1" class="centered" v-if="load" :chart-data="dashboard.chart1"
                          :options="options1" style="max-height:400px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="row">
                  <div class="col-md-12">Percentual de Participação</div>
                  <div class="col-md-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Mês</th>
                          <th scope="col">Percentual</th>
                        </tr>
                      </thead>
                      <tbody v-if="dashboard.chart1">
                        <tr v-for="pct in dashboard.chart1.percentual" :key="pct.month">
                          <td scope="row" align="center">{{ pct.month }}</td>
                          <td>{{ pct.pc }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-content" style="min-height: 400px">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Ranking por Áreas
                      <span class="subtitle">Áreas com maior participação nas reuniões de DDS.</span>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <BarChart id="Chart1" class="centered" v-if="load" :chart-data="dashboard.chart2"
                          :options="options1" style="max-height:400px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-content" style="min-height: 400px">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Ranking por Temas
                      <span class="subtitle">Temas com maior participação nas reuniões de DDS.</span>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <BarChart id="Chart" class="centered" v-if="load" :chart-data="dashboard.chart3"
                          :options="options1" style="max-height:400px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Aba Checklist -->
        <div class="tab-pane" :class="{ 'show active': activeTab === 'checklist' }" id="checklist" role="tabpanel">
          <div class="ibox-content" style="min-height: 400px">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Status dos Checklists
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <BarChart v-if="loadChecklist" :chart-data="checklistData.statusChart" :options="options1" style="max-height:300px" />
                      </div>
                      <div class="col-md-6">
                        <BarChart v-if="loadChecklist" :chart-data="checklistData.categoryChart" :options="options1" style="max-height:300px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Desempenho por Área
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Área</th>
                              <th>Total de Checklists</th>
                              <th>Completos</th>
                              <th>Em Andamento</th>
                              <th>Percentual de Conclusão</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="area in checklistData.areas" :key="area.id">
                              <td>{{ area.name }}</td>
                              <td>{{ area.total }}</td>
                              <td>{{ area.completed }}</td>
                              <td>{{ area.in_progress }}</td>
                              <td>
                                <div class="progress">
                                  <div class="progress-bar" :style="{ width: area.completion_rate + '%', backgroundColor: area.color }">
                                    {{ area.completion_rate }}%
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Aba Ocorrências -->
        <div class="tab-pane" :class="{ 'show active': activeTab === 'ocorrencias' }" id="ocorrencias" role="tabpanel">
          <div class="ibox-content" style="min-height: 400px">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Status das Ocorrências
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <BarChart v-if="loadNonconformity" :chart-data="nonconformityData.statusChart" :options="options1" style="max-height:300px" />
                      </div>
                      <div class="col-md-6">
                        <BarChart v-if="loadNonconformity" :chart-data="nonconformityData.areaChart" :options="options1" style="max-height:300px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Ocorrências por Tipo
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <BarChart v-if="loadNonconformity && nonconformityData.typeChart" :chart-data="nonconformityData.typeChart" :options="options1" style="max-height:300px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title mb-2">
                      Detalhes das Ocorrências
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Área</th>
                              <th>Equipe</th>
                              <th>Total de Ocorrências</th>
                              <th>Em Aberto</th>
                              <th>Resolvidas</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in nonconformityData.details" :key="item.id">
                              <td>{{ item.branch_name }}</td>
                              <td>{{ item.team_name }}</td>
                              <td>{{ item.total }}</td>
                              <td>{{ item.open }}</td>
                              <td>{{ item.resolved }}</td>
                              <td>
                                <span class="badge" :style="{ backgroundColor: item.status_color }">
                                  {{ item.status }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./Charts/BarChart.js";
import Datepicker from "vuejs-datepicker";
import vueSignature from "vue-signature";


export default {
  components: {
    BarChart,
    Datepicker,
    vueSignature,
  },
  data() {
    return {
      load: false,
      loadChecklist: false,
      loadNonconformity: false,
      option: {},
      options1: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      },
      disabled: false,
      dataUrl: "",
      dashboard: {},
      modalTermoOpen: false,
      term: {},
      sendUser: {},
      startDate: null,
      endDate: null,
      activeTab: 'dds',
      checklistData: {
        statusChart: {
          labels: ['Completo', 'Em Andamento'],
          datasets: [{
            label: 'Status dos Checklists',
            data: [0, 0],
            backgroundColor: ['#149414', '#3a87ad']
          }]
        },
        categoryChart: {
          labels: [],
          datasets: [{
            label: 'Checklists por Categoria',
            data: [],
            backgroundColor: []
          }]
        },
        areas: []
      },
      nonconformityData: {
        statusChart: {
          labels: ['Em Aberto', 'Resolvidas'],
          datasets: [{
            label: 'Status das Ocorrências',
            data: [0, 0],
            backgroundColor: ['#dc3545', '#28a745']
          }]
        },
        areaChart: {
          labels: [],
          datasets: [{
            label: 'Ocorrências por Área',
            data: [],
            backgroundColor: []
          }]
        },
        typeChart: {
          labels: [],
          datasets: [{
            label: 'Ocorrências por Tipo',
            data: [],
            backgroundColor: []
          }]
        },
        details: []
      }
    };
  },
  methods: {
    async fetchDashboardData() {
      this.load = false;
      try {
        const api = this.$store.state.api + "dashboard";
        const response = await axios.post(api, {
          start_date: this.startDate,
          end_date: this.endDate
        });
        this.dashboard = response.data;
        this.load = true;
      } catch (error) {
        console.error('Erro ao buscar dados do dashboard:', error);
      }
    },
    handleAccept() {
      this.captureSignature();
      this.updatePolitics(this.sendUser);
    },
    captureSignature() {
      const canvas = document.querySelector('#signature canvas');
      if (canvas) {
        this.dataUrl = canvas.toDataURL('image/png');
        console.log("Signature Data URL:", this.dataUrl);
      } else {
        console.error("Canvas element not found");
      }
    },
    dataURLToBlob(dataUrl) {
      console.log(dataUrl);
      let arr = dataUrl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    async updatePolitics(sendUser) {
      let api = this.$store.state.api + "update-users-terms"
      let currentDate = new Date().toISOString().split('T')[0];
      let fd = new FormData();

      fd.append("user_id", sendUser.id);
      fd.append("name", sendUser.name);
      fd.append("email", sendUser.email);
      fd.append("registry", sendUser.registry);
      // fd.append("shift_id", sendUser.shift_id);
      // fd.append("role_id", sendUser.role_id);
      // fd.append("team_id", sendUser.team_id);
      // fd.append('userType', sendUser.userType);
      // fd.append('user_branches', sendUser.user_branches ? sendUser.user_branches : '');

      let signatureBlob = this.dataURLToBlob(this.dataUrl);

      console.log(signatureBlob);
      if (!signatureBlob || signatureBlob.size <= 1808) {
        swal({
          title: "Assinatura necessária",
          text: "Por favor, adicione sua assinatura antes de prosseguir.",
          icon: "warning",
          button: "OK"
        });
        return;
      }

      fd.append('term_signature_photo', signatureBlob, 'signature.png');
      fd.append("term_accepted", 1);
      fd.append("term_accepted_at", currentDate);      

      try {
        await axios.post(api, fd);
        this.$message("Sucesso", `Informações guardadas com sucesso`, "success");
        this.modalTermoOpen = false;
        await this.fetchDashboardData();  // Atualize os dados do dashboard após a atualização dos dados do usuário
        $('#modalTermoLabel').hide();
      } catch (error) {
        this.errors = error.response.data;
        this.$message(null, this.errors, "error");
      }
    },
    logout() {
      let api = this.$store.state.api + "logout";
      axios.post(api).then((response) => {
        localStorage.removeItem("token");
        this.$router.push({ path: "/domains/login" });
      }).catch((error) => {
        this.errors = error.response.data.errors;
        this.$message("Erro", "Erro ao realizar logout", "error");
      });
    },
    async bringData() {
      const api = this.$store.state.api + "me";
      try {
        const response = await axios.post(api);
        this.user = response.data;
        let firstLogin = this.user.term_accepted;
        this.sendUser = this.user;
        this.userMessagePolitics(firstLogin, this.sendUser);
        await this.fetchDashboardData();  // Atualize os dados do dashboard após trazer os dados do usuário
      } catch (error) {
        this.$message("Erro", error.response.data, "error");
      }
    },
    userMessagePolitics(firstLogin, sendUser) {
      if (firstLogin == 0) {
        const api = this.$store.state.api + "termsOfUses/latest";
        axios.get(api).then((response) => {
          if (response.data[0]) {

            console.log(response.data)
            this.term = response.data[0];
            this.sendUser = sendUser;
            // this.modalTermoOpen = true;
            $('#modalTermoLabel').show();
          }
        }).catch((error) => {
          this.$message(null, "Não foi possível encontrar o termo de uso", "error");
        });
      }
    },
    async getDashboards() {
      await this.fetchDashboardData();  // Use o método fetchDashboardData para buscar e atualizar os dados do dashboard
    },
    async fetchChecklistData() {
      try {
        const api = this.$store.state.api + "checklists/dashboard";
        console.log('Fetching checklist data from:', api);
        const response = await axios.get(api);
        console.log('Checklist data received:', response.data);
        
        if (response.data) {
          this.checklistData = {
            statusChart: {
              labels: ['Completo', 'Em Andamento'],
              datasets: [{
                label: 'Status dos Checklists',
                data: [
                  response.data.statusChart.datasets[0].data[0] || 0,
                  response.data.statusChart.datasets[0].data[1] || 0
                ],
                backgroundColor: ['#149414', '#3a87ad']
              }]
            },
            categoryChart: response.data.categoryChart,
            areas: response.data.areas
          };
          this.loadChecklist = true;
          console.log('Checklist data processed:', this.checklistData);
        }
      } catch (error) {
        console.error('Erro ao buscar dados do checklist:', error);
      }
    },
    async fetchNonconformityData() {
      try {
        const api = this.$store.state.api + "nonconformities/dashboard";
        const response = await axios.get(api);
        this.nonconformityData = response.data;

        this.loadNonconformity = true;
      } catch (error) {
        console.error('Erro ao buscar dados das ocorrências:', error);
      }
    },
    async switchTab(tabId) {
      this.activeTab = tabId;
      if (tabId === 'checklist') {
        await this.fetchChecklistData();
      } else if (tabId === 'ocorrencias') {
        await this.fetchNonconformityData();
      }
    }
  },
  mounted() {
    this.getDashboards();
    this.bringData();
    
    // Inicializa as abas do Bootstrap
    // const triggerTabList = [].slice.call(document.querySelectorAll('#dashboardTabs button'));
    // triggerTabList.forEach(function (triggerEl) {
    //   const tabTrigger = new Tab(triggerEl);
    //   triggerEl.addEventListener('click', function (event) {
    //     event.preventDefault();
    //     tabTrigger.show();
    //   });
    // });
  },
};
</script>


<style scoped>
.card-title {
  font-size: 18px !important;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 14px !important;
  font-style: italic;
  font-weight: 400;
  color: #6c757d;
}

.mt-2 {
  margin-top: 2rem;
}

.mt-3 {
  margin-top: 3rem;
}

.mb-2 {
  margin-bottom: 1rem;
}

.new-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Estilos das Abas */
.nav-tabs {
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 2rem;
  padding: 0 1rem;
}

.nav-tabs .nav-item {
  margin-bottom: -2px;
}

.nav-tabs .nav-link {
  color: #6c757d;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 1rem 2rem;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
}

.nav-tabs .nav-link:hover {
  color: #2c3e50;
  border-color: transparent;
  background-color: #f8f9fa;
}

.nav-tabs .nav-link.active {
  color: #2c3e50;
  background-color: transparent;
  border-color: #3498db;
  border-bottom-width: 2px;
}

/* Estilos dos Painéis */
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  margin-bottom: 2rem;
  background: #fff;
}

.card:hover {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #e9ecef;
  padding: 1.5rem;
  border-radius: 10px 10px 0 0 !important;
}

.card-body {
  padding: 1.5rem;
}

/* Estilos do Conteúdo das Abas */
.tab-content {
  padding: 1rem;
}

.tab-pane {
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tab-pane.show.active {
  display: block;
  opacity: 1;
}

/* Estilos do Container Principal */
.ibox {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.ibox-title {
  padding: 1.5rem;
  border-bottom: 1px solid #e9ecef;
  font-weight: 600;
  color: #2c3e50;
  font-size: 1.2rem;
}

.ibox-content {
  padding: 1.5rem;
}

/* Estilos da Tabela */
.table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
  color: #2c3e50;
  font-weight: 600;
  padding: 1rem;
}

.table tbody td {
  padding: 1rem;
  vertical-align: middle;
}

/* Estilos dos Botões */
.btn-primary {
  background-color: #3498db;
  border-color: #3498db;
  padding: 0.5rem 1.5rem;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #2980b9;
  border-color: #2980b9;
  transform: translateY(-1px);
}

/* Estilos dos Inputs */
.form-control {
  border-radius: 5px;
  border: 1px solid #e9ecef;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 0.2rem rgba(52, 152, 219, 0.25);
}

/* Estilos do Filtro de Datas */
.mt-5.mb-5 {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 1.5rem;
  margin: 2rem 0;
}

.form-label {
  color: #2c3e50;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.progress {
  height: 20px;
  background-color: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: 500;
}

.badge {
  padding: 0.5em 1em;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue